import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const stakeholderGroupDefinition: ResourceDefinition = {
  title: 'Stakeholder Groups',
  nameSingular: 'stakeholder group',
  namePlural: 'stakeholder groups',
  className: 'StakeholderGroup',
  mainIdentifier: 'name',
  slug: 'taxonomies/stakeholder-groups',
  path: 'stakeholder-groups',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (stakeholderGroup) => ({
        type: ActionType.Link,
        link: {
          path: `${stakeholderGroupDefinition.path}/${stakeholderGroup.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (stakeholderGroup) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: stakeholderGroup,
          definition: stakeholderGroupDefinition
        }
      })
    }
  ]
}
